import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

/**
 * Copies a URL to the clipboard with an inline "Copied!" confirmation.
 * Self-contained (no toast dependency) so it works on public pages without login.
 */
export default function CopyLinkButton({
  url,
  label = "Copy Recruiting Profile Link",
  copiedLabel = "Link Copied!",
  className = "",
  testid = "copy-profile-link",
  onCopied,
}) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    const value = url || (typeof window !== "undefined" ? window.location.href : "");
    if (onCopied) { try { onCopied(); } catch (_) {} }
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
      } else {
        const ta = document.createElement("textarea");
        ta.value = value;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      /* noop */
    }
  };

  return (
    <button
      type="button"
      data-testid={testid}
      onClick={copy}
      aria-live="polite"
      className={
        className ||
        `inline-flex items-center justify-center gap-2 w-full px-4 py-2.5 text-xs font-semibold uppercase tracking-wider rounded-sm transition-colors ${
          copied ? "bg-emerald-600 text-white" : "bg-[#0A192F] hover:bg-[#1a2a4a] text-white"
        }`
      }
    >
      {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
      {copied ? copiedLabel : label}
    </button>
  );
}
